import { where } from "firebase/firestore";
import { getRevenda, getUsuario } from '../../config/auth';
import { Collection, WhereField } from '../../shared/constants';
import { chunkItemsByQuantity, documentMask, isNullOrEmpty, normalizedField, takeIfIsNotNullOrEmpty } from '../../shared/utils';
import { addDoc, getAllDocs, getAllDocsByClientId, getAllDocsByQueries, getAllDocsByRevendaId, getCountByQueries, getDocById, updateDoc } from './collectionBaseWorker';

export const addPark = async ({ clienteId, nome, email, phone, document, nomeInterno, representante, horarios, address, revendaId }) => {
    const data = {
        nome: nome,
        nomeInterno: nomeInterno ?? nome,
        celular: phone,
        documento: documentMask(document),
        horarios: horarios ?? "Horario de funcionamento",
        clienteId: clienteId,
        createdAt: new Date(),
        createdBy: email,
        representante: representante ?? nome,
        revendaId: revendaId ?? getRevenda()?.id,
        endereco: {
            id: "",
            cep: address?.cep,
            logradouro: address?.logradouro ?? "Endereço de exemplo",
            numero: address?.numero ?? "123",
            bairro: address?.bairro,
            cidade: address?.cidade,
            estado: address?.estado,
            ibge: address?.ibge,
            complemento: address?.complemento
        },
        status: "Ativo",
        tipoDocumento: normalizedField(document).length === 11 ? "CPF" : "CNPJ",
        isDeleted: false,
    }
    const doc = await addDoc({ collection: Collection.PARK, data: data })
    return doc.id;
}

export const countParksByReseleId = async ({ revendaId }) => {
    const quantity = await getCountByQueries({
        collection: Collection.PARK, queries: [
            where(WhereField.REVENDAID, "==", revendaId),
        ]
    })
    return quantity
}

export const getAllParksByRevendaId = async ({ revendaId }) => {
    return getAllDocsByRevendaId({ collection: Collection.PARK, revendaId: revendaId })
}

export const getAllParksByClientId = async ({ clientId }) => {
    if (clientId) {
        const result = await getAllDocsByClientId({ collection: Collection.PARK, clienteId: clientId })
        return result.sort((a, b) => (takeIfIsNotNullOrEmpty(a.nomeInterno) ?? a.nome).localeCompare(takeIfIsNotNullOrEmpty(b.nomeInterno) ?? b.nome))
    }
    return []
}

export const getAllParksByParksIds = async ({ estacionamentosIds }) => {
    if (!isNullOrEmpty(estacionamentosIds)) {
        return await getAllDocsByQueries({
            collection: Collection.PARK,
            queries: [
                where(WhereField.ID, 'in', estacionamentosIds)
            ]
        })
    }
    return []
}
export const getAllParksByIds = async ({ ids }) => {
    var result = []
    const chunckIds = chunkItemsByQuantity({ items: ids })
    for (const ids of chunckIds) {
        const items = await getAllDocsByQueries({
            collection: Collection.PARK,
            queries: [
                where(WhereField.ID, 'in', ids)
            ]
        })
        result.push(...items)
    }
    return result.sort((a, b) => a.nome.localeCompare(b.nome))
}

export const getAllParks = async () => {
    return await getAllDocs({ collection: Collection.PARK })
}

export const getAllParksByRessaleId = async ({ id }) => {
    return await getAllDocsByRevendaId({ collection: Collection.PARK, revendaId: id })
}

export const getParkById = async ({ id }) => {
    return await getDocById({ collection: Collection.PARK, id: id })
}

export const updateParkRevendaId = async ({ id, revendaId }) => {
    const data = {
        revendaId: revendaId,
        changeRevendaBy: getUsuario()?.nome,
        changeRevendaAt: new Date()
    }
    await updateDoc({ collection: Collection.PARK, id: id, data: data })
}

export const updateParkById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.PARK, id: id, data: data })
}
